import { DefaultTheme } from "styled-components";

export const theme:DefaultTheme = {
    textColor_base : 'rgba(255, 255, 255, 1)',
    textColor_inactive : 'rgba(255, 255, 255, 0.65)',
};